import { useAction, useAtom } from '@reatom/npm-react'
import { useKeyPressEvent } from 'react-use'

import {
  instantTradeDialogVisibleAtom,
  openInstantTradeDialogAction,
} from '../atoms'

import type { InstantTradeTab } from '../atoms'

export const useInstantDialogHotkeys = () => {
  const [isVisible, setVisible] = useAtom(instantTradeDialogVisibleAtom)
  const openInstantTradeDialog = useAction(openInstantTradeDialogAction)

  const handleKeyPress = (
    e: KeyboardEvent,
    tab: InstantTradeTab | undefined,
  ) => {
    if (
      e.target instanceof HTMLInputElement ||
      e.target instanceof HTMLTextAreaElement ||
      !isVisible
    ) {
      return
    }

    if (!tab) {
      setVisible(false)
      return
    }

    openInstantTradeDialog(tab)
  }

  useKeyPressEvent('Escape', (e) => handleKeyPress(e, undefined))
  // Temporarily suppress hotkeys, uncomment when new designs are ready
  // useKeyPressEvent('1', (e) => {
  //   handleKeyPress(e, 'swap')
  // })
  // useKeyPressEvent('2', (e) => {
  //   handleKeyPress(e, 'wallets')
  // })
  // useKeyPressEvent('3', (e) => {
  //   handleKeyPress(e, 'settings')
  // })
}
